import {
  graphLightRed,
  graphPictonBlue,
  graphSandyBrown,
  graphSunglow,
  graphTropicalIndigo,
  pinkBase,
  primaryBase,
} from '../../../../styles/design-tokens';
import { Phase } from './flow-by-phase-tab.type';

const PHASES: Phase[] = [
  Phase.Backlog,
  Phase.Blocked,
  Phase.Wip,
  Phase.Review,
  Phase.Test,
  Phase.Deployable,
  Phase.Done,
];

const PHASES_METADATA = [
  {
    id: Phase.Backlog,
    label: 'Ready',
    color: graphTropicalIndigo,
  },
  {
    id: Phase.Blocked,
    label: 'Blocked',
    color: graphLightRed,
  },
  {
    id: Phase.Wip,
    label: 'WIP',
    color: graphSandyBrown,
  },
  {
    id: Phase.Review,
    label: 'In Review',
    color: graphSunglow,
  },
  {
    id: Phase.Test,
    label: 'In Test',
    color: pinkBase,
  },
  {
    id: Phase.Deployable,
    label: 'To Deploy',
    color: graphPictonBlue,
  },
  {
    id: Phase.Done,
    label: 'Done',
    color: primaryBase,
  },
];

export { PHASES, PHASES_METADATA };
